import React from "react";
import { useParams } from "react-router-dom";
import { Editor } from "@monaco-editor/react";

const sections = [
  "data-preparation",
  "model-definition",
  "training-configuration",
  "evaluation",
  "visualization",
];

const ViewCodebase = () => {
  const { id } = useParams();
  let savedCodebases = [];

  try {
    savedCodebases = JSON.parse(localStorage.getItem("codebases") || "[]");
  } catch (error) {
    console.warn("Invalid saved codebases data, resetting view state.", error);
    savedCodebases = [];
  }

  const codebase = Array.isArray(savedCodebases) ? savedCodebases[id] : null;

  if (!codebase) {
    return <p>Codebase not found.</p>;
  }

  return (
    <div className="container mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">Viewing {codebase.name}</h2>

      {sections.map((section) => (
        <div key={section} className="mb-6">
          <h3 className="text-lg font-semibold mb-2 capitalize">{section.replace("-", " ")}</h3>
          <Editor
            height="200px"
            defaultLanguage="python"
            theme="vs-dark"
            value={codebase[section] || ""}
            options={{ readOnly: true }} // Read-only mode
          />
        </div>
      ))}
    </div>
  );
};

export default ViewCodebase;
